<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>

            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="addForm.institutionCode" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="残疾人姓名" required prop="name">
                <el-input v-model="addForm.name" placeholder="请输入残疾人姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="紧急联系人" required prop="urgencyContact">
                <el-input v-model="addForm.urgencyContact" placeholder="请输入紧急联系人"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="紧急联系人手机" required prop="urgencyPhone">
                <el-input v-model="addForm.urgencyPhone" placeholder="请输入紧急联系人手机"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="残疾人手机号">
                <el-input v-model="addForm.phone" minlength="11" placeholder="请输入残疾人手机号"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="残疾人身份证号">
                <el-input v-model="addForm.idCard" placeholder="请输入残疾人身份证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="家庭地址">
                <el-input v-model="addForm.homeAddress" placeholder="请输入家庭地址"></el-input>
              </el-form-item>
            </el-col>


          </el-row>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm('addForm')">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: 'Add',
  props: ['arr_ins'],
  data() {
    return {

      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        institutionCode:'',

        name: '',
        urgencyContact:'',
        urgencyPhone:'',

        phone:'',
        idCard: '',
        homeAddress: '',

      },

      rules:{

        institutionCode:[
          { required: true, message: '请选择机构', trigger: 'blur' },
        ],
        name:[
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        urgencyContact:[
          { required: true, message: '请输入紧急联系人', trigger: 'blur' },
        ],
        urgencyPhone:[
          { required: true, message: '请输入紧急联系人手机号', trigger: 'blur' },
        ],

      },

    }
  },
  methods: {
    init(){
      this.$refs.addForm.resetFields();

      this.addForm.institutionCode = '';

      this.addForm.name = '';
      this.addForm.urgencyPhone = '';
      this.addForm.urgencyContact = '';

      this.addForm.phone = '';
      this.addForm.idCard = '';
      this.addForm.homeAddress = '';

    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          return false;
        }
      })
    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyAdm/GovAddIns",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    }


  }
}


</script>

